import { createSelector } from '@reduxjs/toolkit';
import { RootState } from 'types/RootState';

const selectDomain = (state: RootState) => state.candidateDocuments || [];
export const selectedCandidateDocumentsFromPassport = createSelector(
  [selectDomain],
  passportDoc => passportDoc.candidatePassportDocuments,
);
